// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { BaseItem, ColumnData } from '../BaseItem';
import { ColumnParams } from '../ColumnParams';
import { QuickTableEditingInfo } from '../../elements/QuickTable/QuickTableMisc';
import { DynProperty } from '@shared/commons/DynProperty';
import { TerceraChartActionProcessor } from '@front/chart/TerceraChartActionProcessor/TerceraChartActionProcessor';
import { TableTotalsVisibility } from '../TableTotalsVisibility';
import { QTAlignment } from '../../elements/QuickTable/QuickTableColumn';
export class DrawingsManagerItem extends BaseItem {
    constructor(tool) {
        super();
        this.Tool = tool;
        this.QuickTableEditingInfoMap[DrawingsManagerItem.SHOWONCHART_COL_INDEX] = new QuickTableEditingInfo(DynProperty.SHOW_ON_CHART_BUTTON);
        const settingsButton = new QuickTableEditingInfo(DynProperty.SETTINGS_BUTTON);
        settingsButton.TooltipKey = 'ObjectManagerItem.Settings.ToolTip';
        this.QuickTableEditingInfoMap[DrawingsManagerItem.SETTINGS_COL_INDEX] = settingsButton;
        const closeButton = new QuickTableEditingInfo(DynProperty.CLOSE_BUTTON);
        closeButton.TooltipKey = 'ObjectManagerItem.Remove.ToolTip';
        this.QuickTableEditingInfoMap[DrawingsManagerItem.REMOVE_COL_INDEX] = closeButton;
    }
    getItemSubject() {
        return this.Tool;
    }
    ColumnCount() {
        return DrawingsManagerItem.columnsParams.length;
    }
    GetColumnParams(i) {
        const columnParams = DrawingsManagerItem.columnsParams[i];
        columnParams.Hidden = columnParams.DefaultHidden;
        return columnParams;
    }
    GetMenuIndex(headerKey) {
        if (DrawingsManagerItem.ListMenuIndex[headerKey]) {
            return DrawingsManagerItem.ListMenuIndex[headerKey];
        }
        else {
            return 1000;
        }
    }
    getColumnValue(column) {
        const toolStateInfoDict = TerceraChartActionProcessor.ToolStateInfoDict;
        const toolType = this.Tool.ToolType;
        switch (column) {
            case DrawingsManagerItem.NAME_COL_INDEX:
                return Resources.getResource(toolStateInfoDict[toolType].locKey);
            case DrawingsManagerItem.WINDOW_COL_INDEX:
                if (this.Tool.WindowsNumber === 0) {
                    return Resources.getResource('ChartObjectManager.mainWindow');
                }
                else {
                    return `${Resources.getResource('ChartObjectManager.subWindow')} ${this.Tool.WindowsNumber}`;
                }
            default:
                return '';
        }
    }
    getColumnData(column) {
        const value = this.getColumnValue(column);
        let FormattedValue = null;
        switch (column) {
            case DrawingsManagerItem.NAME_COL_INDEX:
                FormattedValue = value;
                break;
            case DrawingsManagerItem.WINDOW_COL_INDEX:
                FormattedValue = value;
                break;
        }
        return new ColumnData(value, FormattedValue);
    }
}
DrawingsManagerItem.NAME_COL_INDEX = 0;
DrawingsManagerItem.WINDOW_COL_INDEX = 1;
DrawingsManagerItem.SHOWONCHART_COL_INDEX = 2;
DrawingsManagerItem.SETTINGS_COL_INDEX = 3;
DrawingsManagerItem.REMOVE_COL_INDEX = 4;
DrawingsManagerItem.columnsParams = [
    new ColumnParams('ObjectManagerItem.Name', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Window', 70, QTAlignment.Left, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Show on chart', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Settings', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false),
    new ColumnParams('ObjectManagerItem.Remove', 70, QTAlignment.Center, TableTotalsVisibility.None, true, false)
];
DrawingsManagerItem.ListMenuIndex = [
    'ObjectManagerItem.Name',
    'ObjectManagerItem.Window',
    'ObjectManagerItem.Show on chart',
    'ObjectManagerItem.Settings',
    'ObjectManagerItem.Remove'
];
